import { ROLE } from "@/utils/constant";
import { SidebarMenuConfig } from "./nav-config";
import { createElement } from "react";
import {
  ChartColumn,
  CirclePile,
  ClipboardCheck,
  Grid2X2Check,
  Group,
  HandCoins,
  List,
  ListRestart,
  Loader,
  MonitorCheck,
  Send,
  Split,
  TicketCheck,
  Waypoints,
} from "lucide-react";

export const navE2EPermit: SidebarMenuConfig[] = [
  {
    href: "permit",
    label: "Permit",
    child: [
      {
        href: "/permit-lastmile/assign-vendor",
        label: "Assign Vendor",
        icon: createElement(HandCoins, { width: 20, height: 20 }),
        allowedRoles: [ROLE.FUNNEL_PROJECT, ROLE.ADMINISTRATOR],
      },
      {
        href: "/permit-lastmile/request-expansion-funnel-project",
        label: "Request Expansion Funnel Project",
        icon: createElement(Send, { width: 20, height: 20 }),
        allowedRoles: [ROLE.FUNNEL_PROJECT],
      },
      {
        href: "/permit-lastmile/request-open-access-funnel-project",
        label: "Request Open Access",
        icon: createElement(Send, { width: 20, height: 20 }),
        allowedRoles: [ROLE.FUNNEL_PROJECT, ROLE.ADMINISTRATOR],
      },
      {
        href: "/permit-lastmile/request-re-permit-funnel-project",
        label: "Request Re Permit",
        icon: createElement(Send, { width: 20, height: 20 }),
        allowedRoles: [ROLE.FUNNEL_PROJECT],
      },
      {
        href: "/permit-lastmile/compensation-approval-permit-monitoring",
        label: "Compensation Approval",
        icon: createElement(TicketCheck, { width: 20, height: 20 }),
        allowedRoles: [ROLE.PERMIT_MONITORING],
      },
      {
        href: "/permit-lastmile/compensation-approval-project-operation-lead",
        label: "Compensation Approval",
        icon: createElement(TicketCheck, { width: 20, height: 20 }),
        allowedRoles: [ROLE.PROJECT_OPERATIONAL_LEAD],
      },
      {
        href: "/permit-lastmile/compensation-approval-project-manager",
        label: "Compensation Approval",
        icon: createElement(TicketCheck, { width: 20, height: 20 }),
        allowedRoles: [ROLE.PROJECT_MANAGER],
      },
      {
        href: "/permit-lastmile/review-compensation-permit-dispatch",
        label: "List Permit Approve",
        icon: createElement(List, { width: 20, height: 20 }),
        allowedRoles: [ROLE.PERMIT_DISPATCH, ROLE.PERMIT_VIEW],
      },
      {
        href: "/permit-lastmile/validate-permit-reject-permit-monitoring",
        label: "List Permit Reject Monitoring",
        icon: createElement(List, { width: 20, height: 20 }),
        allowedRoles: [ROLE.ADMINISTRATOR, ROLE.PERMIT_MONITORING],
      },
      {
        href: "/permit-lastmile/validate-permit-reject-permit-dispatch",
        label: "List Permit Reject Dispatch",
        icon: createElement(List, { width: 20, height: 20 }),
        allowedRoles: [ROLE.PERMIT_DISPATCH, ROLE.PERMIT_VIEW],
      },
      {
        href: "/permit-lastmile/request-expansion-funnel-management",
        label: "Request Expansion Funnel Management",
        icon: createElement(Send, { width: 20, height: 20 }),
        allowedRoles: [ROLE.FUNNEL_MANAGEMENT],
      },
      {
        href: "/permit-lastmile/change-request-re-permit-funnel-management",
        label: "CR Re-Permit",
        icon: createElement(ListRestart, { width: 20, height: 20 }),
        allowedRoles: [ROLE.FUNNEL_MANAGEMENT, ROLE.ADMINISTRATOR],
      },
      {
        href: "/permit-lastmile/permit-progress",
        label: "Permit Progress",
        icon: createElement(Loader, { width: 20, height: 20 }),
        allowedRoles: [ROLE.VENDOR, ROLE.VENDOR_VIEW],
      },
      {
        href: "/permit-lastmile/re-permit-vendor",
        label: "Re-permit",
        icon: createElement(ListRestart, { width: 20, height: 20 }),
        allowedRoles: [ROLE.VENDOR, ROLE.VENDOR_VIEW],
      },
      {
        href: "/permit-issue/permit-issue-list",
        label: "Permit Issue List",
        icon: createElement(List, { width: 20, height: 20 }),
        allowedRoles: [
          ROLE.VENDOR,
          ROLE.PERMIT_DISPATCH,
          ROLE.PERMIT_MONITORING,
          ROLE.PROJECT_OPERATIONAL_LEAD,
          ROLE.PROJECT_MANAGER,
          ROLE.PERMIT_VIEW,
          ROLE.VENDOR_VIEW,
        ],
      },
      {
        href: "/permit-reimbursement/permit-reimbursement-list",
        label: "Permit Reimbursement List",
        icon: createElement(List, { width: 20, height: 20 }),
        allowedRoles: [
          ROLE.VENDOR,
          ROLE.PERMIT_DISPATCH,
          ROLE.PERMIT_MONITORING,
          ROLE.PROJECT_OPERATIONAL_LEAD,
          ROLE.PROJECT_MANAGER,
          ROLE.PBO,
          ROLE.PERMIT_VIEW,
          ROLE.VENDOR_VIEW,
        ],
      },
      {
        href: "/permit-lastmile/monitoring-suffix",
        label: "Monitoring Suffix",
        icon: createElement(MonitorCheck, { width: 20, height: 20 }),
        allowedRoles: [
          ROLE.FUNNEL_PROJECT,
          ROLE.PERMIT_DISPATCH,
          ROLE.PERMIT_MONITORING,
          ROLE.PROJECT_OPERATIONAL_LEAD,
          ROLE.PROJECT_MANAGER,
        ],
      },
    ],
  },
];

export const navE2EFunnel: SidebarMenuConfig[] = [
  {
    href: "#",
    label: "Funnel",
    child: [
      {
        href: "/funnel/upload-grouping-funnel",
        label: "Upload Grouping",
        icon: createElement(Group, { width: 20, height: 20 }),
        allowedRoles: [ROLE.FUNNEL_MANAGEMENT],
      },
      {
        href: "/funnel/funnel",
        label: "Funnel List",
        icon: createElement(List, { width: 20, height: 20 }),
        allowedRoles: [ROLE.FUNNEL_MANAGEMENT, ROLE.FUNNEL_VIEW],
      },
      {
        href: "/funnel/update-status-permit",
        label: "Update Status Grouping Funnel",
        icon: createElement(CirclePile, { width: 20, height: 20 }),
        allowedRoles: [ROLE.FUNNEL_MANAGEMENT],
      },
      {
        href: "/funnel/suffix",
        label: "Suffix List",
        icon: createElement(List, { width: 20, height: 20 }),
        allowedRoles: [ROLE.FUNNEL_MANAGEMENT, ROLE.AGG_HLD, ROLE.FUNNEL_VIEW],
      },
    ],
  },
];

export const navE2EAPD: SidebarMenuConfig[] = [
  {
    href: "#",
    label: "APD",
    child: [
      {
        href: "/design-lastmile/dashboard-apd",
        label: "Dashboard",
        icon: createElement(ChartColumn, { width: 20, height: 20 }),
        allowedRoles: [
          ROLE.VENDOR,
          ROLE.LM_FEEDER_DESIGN,
          ROLE.COSTING,
          ROLE.BB_DESIGN,
          ROLE.APD_VIEW,
          ROLE.VENDOR_VIEW,
        ],
      },
      {
        href: "/design-lastmile/network-type",
        label: "Network Type",
        icon: createElement(Waypoints, { width: 20, height: 20 }),
        allowedRoles: [
          ROLE.ADMINISTRATOR,
          ROLE.LM_FEEDER_DESIGN,
          ROLE.APD_VIEW,
        ],
      },
      {
        href: "/design-lastmile/apd-list",
        label: "APD List",
        icon: createElement(List, { width: 20, height: 20 }),
        allowedRoles: [
          ROLE.ADMINISTRATOR,
          ROLE.VENDOR,
          ROLE.LM_FEEDER_DESIGN,
          ROLE.COSTING,
          ROLE.BB_DESIGN,
          ROLE.APD_VIEW,
          ROLE.VENDOR_VIEW,
        ],
      },
      {
        href: "/design-lastmile/define-permit-feeder",
        label: "Define Permit Feeder",
        icon: createElement(ClipboardCheck, { width: 20, height: 20 }),
        allowedRoles: [ROLE.VENDOR, ROLE.VENDOR_VIEW],
      },
      {
        href: "/design-lastmile/reboundary",
        label: "Reboundary",
        icon: createElement(Split, { width: 20, height: 20 }),
        allowedRoles: [ROLE.LM_FEEDER_DESIGN, ROLE.APD_VIEW],
      },
      {
        href: "/design-lastmile/request-reboundary",
        label: "Request Reboundary",
        icon: createElement(Grid2X2Check, { width: 20, height: 20 }),
        allowedRoles: [ROLE.VENDOR, ROLE.VENDOR_VIEW],
      },
      {
        href: "/design-lastmile/rollback-all-list",
        label: "Rollback All List",
        icon: createElement(List, { width: 20, height: 20 }),
        allowedRoles: [
          ROLE.LM_FEEDER_DESIGN,
          ROLE.COSTING,
          ROLE.BB_DESIGN,
          ROLE.FUNNEL_PROJECT,
          ROLE.VENDOR,
          ROLE.APD_VIEW,
          ROLE.VENDOR_VIEW,
        ],
      },
    ],
  },
];

export const navE2EWOManagement: SidebarMenuConfig[] = [
  {
    href: "#",
    label: "WO Management",
    child: [
      {
        href: "/wo-management/nosa",
        label: "NOSA",
        icon: createElement(List, { width: 20, height: 20 }),
        allowedRoles: [ROLE.NOSA, ROLE.WO_VIEW],
      },
      {
        href: "/wo-management/enterprise",
        label: "Enterprise",
        icon: createElement(List, { width: 20, height: 20 }),
        allowedRoles: [ROLE.ENTERPRISE, ROLE.WO_VIEW],
      },
    ],
  },
];
